import { render, staticRenderFns } from "./DomainDetails.vue?vue&type=template&id=de25a794&scoped=true"
import script from "./DomainDetails.vue?vue&type=script&lang=js"
export * from "./DomainDetails.vue?vue&type=script&lang=js"
import style0 from "./DomainDetails.vue?vue&type=style&index=0&id=de25a794&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de25a794",
  null
  
)

export default component.exports